import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/ui/Button"
import styles from "./TelegramAuthError.module.scss"
import {
  TELEGRAM_AUTH_ERROR_ACTION_KEYS,
  telegramAuthErrorAction,
  telegramAuthErrorMessageKey
} from "./helpers"
import { ITelegramAuthErrorProps } from "./types"

export const TelegramAuthError: FC<ITelegramAuthErrorProps> = ({
  cause,
  onRetry,
  onClose
}) => {
  const { t } = useTranslation()

  const action = telegramAuthErrorAction(cause)
  const actionHandlers = { retry: onRetry, close: onClose }

  return (
    <div className={styles.TelegramAuthError} role="alert">
      <p className={styles.TelegramAuthError_message}>
        {t(telegramAuthErrorMessageKey(cause))}
      </p>
      <Button onClick={actionHandlers[action]}>
        {t(TELEGRAM_AUTH_ERROR_ACTION_KEYS[action])}
      </Button>
    </div>
  )
}
